var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"dropdown"}},[_c('div',{staticClass:"ELYXDropdown",style:(_vm.getDropdownPosition)},[(_vm.activeDropdown.name === 'SidebarElementDropdownButton')?_c('SidebarElementDropdownContents'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }